export const isRfcValid = rfc => {
    let re = /^[A-Z,Ñ,&,a-z,ñ]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,a-z,0-9]?[A-Z,a-z,0-9]?[0-9,A-Z,a-z]?$/;
    return re.test(rfc);
}

export const isNumbersOnly = value => {
    let regex = /^\d+$/;
    return regex.test(value);
}

export const isNullOrEmpty = (value) => {
    return typeof value == 'undefined' || !value;
}

export const isEmpty = (str) => {
    return !str || 0 === str.length || /^\s*$/.test(str) || !str.trim()
}

export const isUndefinedOrNull = value => {
    return value === undefined || value === null;
}

/**
 * * 
 * @param values Array of values
 * @param validationFunction Function that returns a boolean
 * @returns {null}
 */
export const allValid = (values, validationFunction) => {
    let result = true;
    values && values.map && values.map(val => result &= validationFunction(val))
    return result;
}